import React, { useEffect, useRef, useState } from 'react';
import { Button, Container, Box, Typography, Card, CardContent, TextField } from '@mui/material';
import MessageIcon from '@mui/icons-material/Message';
import Avatar from '@mui/material/Avatar';
import { BsTelephoneFill } from 'react-icons/bs';
import LeadService from '../../core/services/leadsService';
import { MdEmail } from 'react-icons/md';
import logo_between from '../../../public/assets/logo_between.png';
import logo_white from '../../../public/assets/logo-white.jpeg';
import user_icon from '../../../public/assets/user_icon.jpg';
import { BsJustify } from 'react-icons/bs';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LinearProgress from '@mui/material/LinearProgress';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
const useStyles = makeStyles((theme) => ({
    googleApiServiceImageStyle: {
        width: '100%',
        height: '470px',
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
            width: '1020px',
            height: '470px',
            borderRadius: '10px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1100px',
            height: '470px',
            borderRadius: '10px',
        },
        [theme.breakpoints.up('lg')]: {
            width: '100%',
            height: '470px',
            borderRadius: '10px',
        },
    },
}));
const ServicesJobDetails = () => {
    let { id } = useParams();
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const { job_type, user_type, customerId } = location.state || {};
    const [jobDetail, setJobDetail] = useState(null);

    const [zoomLevel, setZoomLevel] = useState(13);
    const GetJobDetail = async (id, job_type) => {
        try {

            setIsLoadingDetails(true)
            const res = await LeadService.jobDetail(id, job_type);
            if (res.data.success) {
                setJobDetail(res?.data?.jobDetails);


            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoadingDetails(false)
        }
    };

    useEffect(() => {
        GetJobDetail(id, job_type);

    }, [id, job_type]);

    const HandleBackNavigate = (user_type, customerId) => {

        if (user_type === 'customer') {
            navigate(`/customers-details/${customerId}`);
        } else {
            navigate('/jobs');
        }

    }
    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => prevZoom + 1);
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(1, prevZoom - 1));
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingDetails && <LinearProgress />}</div>
            <Box>
                <Button onClick={() => HandleBackNavigate(user_type, customerId)}
                    sx={{ background: '#efefef', padding: '6px', '&:hover': { background: '#cecaca' }, }}>
                    <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>

            </Box>

            <Box>
                {jobDetail === null ? <div style={{ color: '#000000b0', fontSize: '18px', fontWeight: 'bold', justifyContent: 'center', display: 'flex' }}>Data not found.</div> : (
                    <>

                        <Box style={{ marginTop: '20px', position: 'relative', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
                            <div>
                                {/* Google Map Image */}
                                <img
                                    src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=561x190&maptype=roadmap&center=${jobDetail?.job?.latitude},${jobDetail?.job?.longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                    alt="Static map"
                                    className={classes.googleApiServiceImageStyle}
                                    style={{width: '100%'}}
                                />
                                <div style={{ position: 'absolute', top: 4, right: 19 }}>
                                    <Button
                                        onClick={handleZoomIn}
                                        variant="outlined"
                                        style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                    >
                                        <AddIcon />
                                    </Button>
                                    <Button
                                        onClick={handleZoomOut}
                                        variant="outlined"
                                        style={{ fontSize: '12px', fontWeight: '600', background: 'white', color: 'black' }}
                                    >
                                        <RemoveIcon />
                                    </Button>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '199px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '4px',
                                    padding: '5px',
                                }}
                            >
                                <img src={logo_white} alt="" style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }} />
                            </div>
                        </Box>
                        <Box style={{ marginTop: '20px' }}>
                            <Card sx={{ width: 'auto', height: 'auto', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: {
                                    xs: '10px',
                                    sm: '15px',
                                    md: '20px',
                                } }}>
                                    <div sx={{ display: 'flex', gap: {
                                        xs: '10px',
                                        sm: '15px',
                                        md: '20px',
                                    } }}>
                                        <Box>
                                            <Avatar src={logo_between} sx={{ height: '103px', width: '103px' }} />
                                        </Box>

                                        <Box style={{ display: 'grid' }}>
                                            <Box>
                                                <Typography sx={{ fontSize: {
                                                    xs: '18px',
                                                    sm: '24px',
                                                    md: '28px',
                                                }, fontFamily: 'sans-serif', fontWeight: 'bold' }}>
                                                    <span>Agent Name:</span> {jobDetail?.assignto?.name}{' '}{jobDetail?.assignto?.last_name}
                                                </Typography>
                                            </Box>

                                            <Box style={{ display: 'flex', gap: '4px' }}>
                                                <div>
                                                    <Typography sx={{ fontSize: {
                                                    xs: '14px',
                                                    sm: '16px',
                                                    md: '20px',
                                                }, color: '#252F46CC', fontFamily: 'inherit', fontWeight: 'bold' }}>
                                                        Property:{' '}
                                                    </Typography>
                                                </div>
                                                <div>
                                                    <Typography  sx={{ fontSize: {
                                                    xs: '14px',
                                                    sm: '16px',
                                                    md: '20px',
                                                }, color: '#252F46CC', fontFamily: 'inherit' }}>
                                                        {jobDetail?.job?.location}
                                                    </Typography>
                                                </div>
                                            </Box>
                                            <Box style={{ display: 'flex', gap: '4px' }}>
                                                {jobDetail?.services?.map((service, index) => (
                                                    <Box key={service.id} style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '10px' }}>
                                                        <Typography sx={{ fontSize: {
                                                            xs: '14px',
                                                            sm: '18px',
                                                            md: '24px',
                                                        }, color: '#252F46CC', fontFamily: 'inherit', fontWeight: 'bold' }}>
                                                            Service {index + 1}:
                                                        </Typography>
                                                        
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: {
                                                            xs: '14px',
                                                            sm: '16px',
                                                            md: '18px',
                                                        }, }}>Service Name: <span style={{fontWeight: 'normal'}}>{service?.service_name}</span></Typography> 
                                                        
                                                        
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: {
                                                            xs: '14px',
                                                            sm: '16px',
                                                            md: '18px',
                                                        } }}>Price: 
                                                        <span style={{fontWeight: 'normal'}}>
                                                        {' '}
                                                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(service?.price)}
                                                        </span></Typography>
                                                        
                                                        
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: {
                                                            xs: '14px',
                                                            sm: '16px',
                                                            md: '18px',
                                                        } }}> Date:
                                                        {service?.created_at && (
                                                                <span style={{fontWeight: 'normal'}}>
                                                                    {' '}
                                                                    {formatDateTime(adjustTimeBasedOnOffsetForReceivedData(service?.created_at, getUserOffset()))}
                                                                </span>
                                                            )}
                                                            </Typography>
                                                            
                                                        
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    </div>
                                </Box>
                            </Card>
                        </Box>
                    </>
                )}
            </Box>
        </>
    );
};
export default ServicesJobDetails;
